import styled from 'styled-components'  
import { PrimaryColor } from 'ui/styled';
 
export const DashboardHeaderContainer = styled.div.attrs({ 
})`           
    height: 105px;
    width: 100%;

    //background: linear-gradient(45deg, rgba(${PrimaryColor}, .45) 0%, rgba(${PrimaryColor}, .6) 25%, rgba(${PrimaryColor}, .75) 50%, rgba(${PrimaryColor}, .9) 75%, rgba(${PrimaryColor}, 1) 100%);
    background: var(--black-color);
    padding: 0 25px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    @media(max-width: 767px){
        flex-direction: row;
        align-items: top;
        height: initial;
    }
`;
 
export const DashboardHeaderSide = styled.div.attrs({ 
})`            
    display: flex;
    justify-content: flex-start;
    align-items: center; 

    position: relative;
`;
 
export const DashboardHeaderSideMobile = styled.div.attrs({ 
})`            
    display: flex;
    justify-content: flex-start;
    align-items: center; 

    @media(max-width: 399px){
        flex-direction: row;
        align-items: center;
        gap: 15px;
    }
`;

export const DashboardHeaderAction = styled.div.attrs({ 
})`           
    color: var(--black-color);
    font-size: 16px;
    cursor: pointer;

    ${
        props => props.active ? `
            font-weight: bold;
        ` : ``
    }

    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 20px;

    cursor: pointer;
    &:hover{
        text-decoration: underline;
    }


    @media(max-width: 767px){
        padding: 0 10px;
    }

    @media(max-width: 399px){
        padding: 10px;
    }
`; 

export const DashboardHeaderActionIcon = styled.img.attrs({ 
})`            
    margin-bottom: -8px;
    margin-right: 10px;
    width: 20%; // Reduz o tamanho para 60% do original (100% - 60%)
    height: auto; // Mantém a proporção da imagem

    @media(max-width: 399px){
        width: 30%;
        height: auto;
        margin-bottom: 0;
        margin-right: 0;
    }
`;

export const DashboardHeaderHomeIcon = styled.img.attrs({ 
})`            
    width: 32px;
    height: 32px;
    margin-right: 15px;
    cursor: pointer;
    filter: invert(1); // Torna o ícone branco
    transition: all 0.2s ease;

    &:hover{
        filter: invert(0.7); // Torna o ícone um pouco mais escuro no hover
        transform: scale(1.1);
    }

    @media(max-width: 399px){
        width: 24px;
        height: 24px;
        margin-right: 0;
    }
`; 